import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'jhiAlphaString'})
export class TrcAlphaStringPipe implements PipeTransform {

    constructor() {
    }

    transform(input: string): string {
        if (input.match(/^[.]/g)) {
            input = '';
        }
        return input.replace(/\s+/g, ' ')
            .replace(/[\d]/g, '')
            .replace(/-+/g, '-')
            .replace(/"+/g, '"')
            .replace(/'+/g, '\'')
            .replace(/\.+/g, '.')
            .replace(/[,\?!@#\$%\°&\*\(\)\²\§\¤_=\+;:<>\/\\\|\}\{\[\]`~]*/g, '');
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/pipes/alpha-string.pipe.ts